import type { LucideIcon } from "lucide-react";
import {
  History,
  Pause,
  Repeat2,
  TrendingDown,
  UserMinus,
} from "lucide-react";
export const MOMENTUM_BLOCKER_BADGE_CLASS =
  "inline-flex items-center gap-1.5 rounded-full border bg-amber-700/10 text-amber-700 border-amber-700/20 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide";

/** Cream panel — title, blocker rows, footer disclaimer */
export const MOMENTUM_BLOCKERS_PANEL_CLASS =
  "rounded-xl border border-warning/30 bg-[#FFF9F0] p-5 space-y-5";

/** Account history page — references the date filter above the panel. */
export const DEAL_MOMENTUM_ACCOUNT_HISTORY_DISCLAIMER =
  "Momentum reflects the complete deal history, regardless of date filters, and updates from the latest call transcript.";

/** Timeline drawer / general context — no date-filter reference. */
export const DEAL_MOMENTUM_DISCLAIMER =
  "Deal Momentum reflects the full deal history across all calls with this account — independent of how any single call was run.";

export const DEAL_MOMENTUM_EMPTY_BLOCKERS_MESSAGE =
  "No active blockers detected. This deal is showing healthy forward motion";

/** Rep detail — no accounts with active blockers for this rep. */
export const REP_NO_ACTIVE_BLOCKERS_MESSAGE =
  "No active blockers across this rep's accounts.";

export {
  DEAL_MOMENTUM_MIN_TRANSCRIPTS_MESSAGE,
  DEAL_MOMENTUM_NO_TRANSCRIPT_MESSAGE,
} from "@/lib/no-transcript";

export function dealMomentumIndicatorLabel(count: number): string {
  return count === 1 ? "1 active indicator" : `${count} active indicators`;
}

type BlockerIconEntry = {
  icon: LucideIcon;
};

/** Icons per blocker key — case-insensitive via normalizeBlockerKey */
const BLOCKER_ICONS: Record<string, BlockerIconEntry> = {
  repeated_resistance: { icon: Repeat2 },
  stalled_next_steps: { icon: Pause },
  stakeholder_retreat: { icon: UserMinus },
  timeline_regression: { icon: History },
  engagement_fade: { icon: TrendingDown },
};

function normalizeBlockerKey(value: string): string {
  return value
    .toLowerCase()
    .replace(/[,_\s]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function getMomentumBlockerIcon(key: string): LucideIcon {
  const normalized = normalizeBlockerKey(key);
  return BLOCKER_ICONS[normalized]?.icon ?? Pause;
}

export function formatMomentumBlockerLabel(blocker: {
  key: string;
  label: string;
}): string {
  const raw = blocker.label?.trim() || blocker.key?.replace(/[,_-]+/g, " ").trim() || "";
  return raw.toUpperCase();
}
